module.exports = __webpack_public_path__ + "media/images/lb/676-18aaf4a7e5ac4ccf365ec74af66eb63d.svg";